import { castArray, includes } from 'lodash';

export const HTTP_OK = 200;
export const HTTP_NO_RESPONSE = 204;
export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_NOT_FOUND = 404;

export function getRequestErrorCode(error) {
    if (typeof error.getStatus === 'function') {
        return error.getStatus();
    }

    return undefined;
}

export function isRequestErrorCode(error, codeOrCodes) {
    const errorCodes = castArray(codeOrCodes);

    return includes(errorCodes, getRequestErrorCode(error));
}

export function isUnauthorizedRequestError(error) {
    return isRequestErrorCode(error, HTTP_UNAUTHORIZED);
}

export function isBadRequestError(error) {
    return isRequestErrorCode(error, HTTP_BAD_REQUEST);
}

export function isNotFoundError(error) {
    return isRequestErrorCode(error, HTTP_NOT_FOUND);
}

export function rethrowError(error) {
    throw error;
}
